import DropDownButton from "devextreme-react/drop-down-button";
import { useLanguage } from "../../hooks/useLanguage";
import "./ItiLanguageSelector.scss";

export default function ItiLanguageSelector() {
	const { t, language, changeLanguage } = useLanguage();

	const languages = [
		{ value: "es", name: t("languages.es"), icon: "es" },
		{ value: "en", name: t("languages.en"), icon: "en" },
	];

	const handleItemClick = (e: any) => {
		changeLanguage(e.itemData.value);
	};

	const itemFlag = (data: any, index: number) => {
		return (
			<div key={index} className="localeContent">
				<div className="language-item">{data.value.toUpperCase()}</div>
			</div>
		);
	};

	return (
		<div className="row">
			<hr className="hr-mobile" />
			<DropDownButton
				text={language.toUpperCase()}
				className="languageDropdown"
				items={languages}
				displayExpr="name"
				keyExpr="value"
				stylingMode="text"
				itemRender={itemFlag}
				onItemClick={handleItemClick}
				width={100}
				dropDownOptions={{ width: "60" }}
			/>
			<hr className="hr-mobile" />
		</div>
	);
}
